import React from 'react'
import cx from 'classnames'
import { IconText } from '@components/UI'
import { ClassroomManager } from '@helpers'
import { useClassroomQuery } from '../../hooks'
import { useClassroomPermissions } from '../../contexts'
import { Classroom as CC } from '../../../../constants'

const Tools = ({ panels }) => {
  const { checkPermission } = useClassroomPermissions()
  const canTogglePanel = checkPermission(CC.FEATURES.TOOL_PANEL_TOGGLE)

  const { data: classroom } = useClassroomQuery()

  const togglePanel = (panel) => {
    if (!canTogglePanel) return
    ClassroomManager.togglePanel(panel)
  }

  return (
    <div
      className={`tools-container ${
        classroom.mode === 'individual' ? 'no-messages' : ''
      }`}
    >
      <span>
        <IconText
          group='a2'
          value='Sketch'
          icon='pencil fill'
          className={cx({
            active: panels.includes('sketch'),
            'is-interactive': canTogglePanel
          })}
          events={{
            onClick: () => {
              if (ClassroomManager.isSynced()) togglePanel('sketch')
            }
          }}
        />
        <IconText
          group='a2'
          value='Notes'
          icon='text'
          className={cx({
            active: panels.includes('note'),
            'is-interactive': canTogglePanel
          })}
          events={{
            onClick: () => {
              if (ClassroomManager.isSynced()) togglePanel('note')
            }
          }}
        />
        <IconText
          group='a2'
          value='Code'
          icon='code-closed'
          className={cx({
            active: panels.includes('code'),
            'is-interactive': canTogglePanel
          })}
          events={{
            onClick: () => {
              if (ClassroomManager.isSynced()) togglePanel('code')
            }
          }}
        />
        <IconText
          group='a2'
          value='Files'
          icon='folder'
          className={cx({
            active: panels.includes('finder'),
            'is-interactive': canTogglePanel
          })}
          events={{
            onClick: () => {
              if (ClassroomManager.isSynced()) togglePanel('finder')
            }
          }}
        />
      </span>
    </div>
  )
}

export default Tools
